import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { usePaywallCouponApi } from "@circle-react/components/PaywallCoupons/Admin/hooks/usePaywallCouponApi";
import { FormTextSelect } from "@circle-react-uikit/Form/FormTextSelect";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";

export const WhichPaywallCouponSelector = (): JSX.Element => {
  const { register } = useFormContext();
  const { useListPaywallCoupons } = usePaywallCouponApi({});
  const {
    data: paywallCoupons,
    isLoading,
    isSuccess,
  } = useListPaywallCoupons();

  const couponOptions = (paywallCoupons || []).map(coupon => ({
    label: coupon.code,
    value: coupon.id,
  }));

  if (isLoading) {
    return <Loader center />;
  }

  if (!isSuccess) {
    return (
      <Typography.LabelXs>
        <span className="text-v2-danger">
          {t("settings.workflows.form.errors.paywall_coupons.fetch_failed")}
        </span>
      </Typography.LabelXs>
    );
  }

  return (
    <>
      <div className="hidden">
        <input type="hidden" {...register("trigger.resource_type")} />
      </div>

      <FormTextSelect
        name="trigger.resource_id"
        label={t("settings.workflows.form.which_paywall_coupon")}
        options={couponOptions}
        rules={{
          required: t("settings.workflows.form.errors.required"),
        }}
        emptyMessage={t(
          "settings.workflows.form.errors.paywall_coupons.not_found",
        )}
      />
    </>
  );
};
